import { render } from "./AddFeederPillarModal.vue?vue&type=template&id=0bf6739d&scoped=true"
import script from "./AddFeederPillarModal.vue?vue&type=script&lang=js"
export * from "./AddFeederPillarModal.vue?vue&type=script&lang=js"

import "./AddFeederPillarModal.vue?vue&type=style&index=0&id=0bf6739d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf6739d"]])

export default __exports__